import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import * as Model from '@square/dashboard-protos/models/squareup/legalentities/model/model';
import TaxIdType from '../../models/tax-id-type';

export default class AgreementRoute extends Route {
  @service currentApplicationFlow;

  setupController(controller) {
    if (
      this.currentApplicationFlow.business.businessType ===
      Model.Business.Structure.Type.SOLE_PROPRIETORSHIP
    ) {
      controller.taxIdType = TaxIdType.SSN;
    }
  }
}
